import React, { useState } from "react";
import { Heart, ShoppingBag } from "lucide-react";
import Reveal from "./Reveal";
import PriceTag from "./PriceTag";

export function ProductCard({ p, index, onAdd }) {
  const [wished, setWished] = useState(false);
  const [pop, setPop] = useState(false);

  function toggleWish() {
    setWished((w) => !w);
    setPop(true);
    setTimeout(() => setPop(false), 450);
  }

  return (
    <Reveal delay={index * 0.06}>
      <div
        className="group relative rounded-2xl overflow-hidden h-full flex flex-col"
        style={{ background: "#171B22", border: "1px solid rgba(255,255,255,0.06)" }}
      >
        <div className="relative h-72 overflow-hidden">
          <img
            src={p.image}
            alt={p.name}
            loading="lazy"
            className="absolute inset-0 w-full h-full transition-transform duration-500 group-hover:scale-105"
            style={{ objectFit: "cover" }}
          />
          <div
            className="absolute inset-0"
            style={{ background: "linear-gradient(180deg, rgba(11,14,19,0.4) 0%, rgba(11,14,19,0) 30%)" }}
          ></div>

          {p.tag && (
            <span
              className="absolute top-4 left-4 text-xs uppercase px-2 py-1 rounded-full tracking-widest"
              style={{ background: "rgba(255,138,0,0.92)", color: "#fff", fontFamily: "'JetBrains Mono', monospace" }}
            >
              {p.tag}
            </span>
          )}

          <button
            onClick={toggleWish}
            className={`absolute top-4 right-4 p-2 rounded-full transition-transform duration-300 hover:scale-110 ${pop ? "heart-pop" : ""}`}
            style={{ background: "rgba(11,14,19,0.7)" }}
            aria-label="Wishlist"
          >
            <Heart size={16} color={wished ? "#FF8A00" : "#F5F1EA"} fill={wished ? "#FF8A00" : "none"} />
          </button>

          <div className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out">
            <button
              onClick={() => onAdd(p)}
              className="w-full py-3 text-sm tracking-widest uppercase flex items-center justify-center gap-2"
              style={{ background: "#1E9AFF", color: "#fff" }}
            >
              Add to Bag <ShoppingBag size={14} />
            </button>
          </div>
        </div>

        <div className="p-5 flex-1 flex flex-col justify-between">
          <div>
            <p
              className="text-xs uppercase tracking-widest opacity-60 mb-1"
              style={{ fontFamily: "'JetBrains Mono', monospace", color: "#F5F1EA" }}
            >
              {p.brand}
            </p>
            <h3 style={{ fontFamily: "Fraunces, serif", color: "#F5F1EA" }} className="text-lg mb-3">
              {p.name}
            </h3>
          </div>
          <PriceTag price={p.price} originalPrice={p.originalPrice} />
        </div>
      </div>
    </Reveal>
  );
}

export default ProductCard;
